import client from "./client";

export default {
  /**
   * @param {String} username
   * @param {String} password
   * @returns {Promise}
   */

  login(username, password) {
    const params = new URLSearchParams();
    params.append("username", username);
    params.append("password", password);

    return client.post("login", params);
  },
};
